import createApi from './CreateApi';

const api =  createApi(process?.env?.REACT_APP_ENDPOINT || '');
export default api